module.exports = __webpack_public_path__ + "static/media/sainikProfile.18e5a1d7.JPG";